<script>
import {computed, defineComponent, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import {useRouter} from "vue-router";
import { useIdleLogout } from '@/composables/useIdleLogout.js'

import TokenService from "@/services/token";

export default defineComponent({

  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    useIdleLogout(15)

    const userInfo = computed(() => store.getters.getProfile)

    const path = computed(() => route.path);

    const authenticate = async () => {
      try {
        if (!TokenService.getAccessToken()) {
          if (path.value === '/') {
            await router.push('/login');
            return;
          }
        }

        await store.dispatch('fetchProfile');
        await store.dispatch('fetchUpdateAuth', true);
      } catch (e) {
        console.error(e);
      }
    };

    onMounted(async () => {
      try {
        await authenticate();
      } catch (e) {}
      if (path.value === '/') {
        if (userInfo.value.permissions.length) {
          if (userInfo.value.permissions[0].name === 'states') {
            await router.push('/state-constructor');
          } else if (userInfo.value.permissions[0].name === 'structure') {
            await router.push('/buildings');
          } else if (userInfo.value.permissions[0].name === 'notifications') {
            await router.push('/notices');
          } else if (userInfo.value.permissions[0].name === 'requisites') {
            await router.push('/vendors/list');
          } else if (userInfo.value.permissions[0].name === 'site') {
            await router.push('/website');
          } else if (userInfo.value.permissions[0].name === 'accounts') {
            await router.push('/personal-accounts');
          } else if (userInfo.value.permissions[0].name === 'through-blocks') {
            await router.push('/blocks');
          }
          else {
            await router.push(`/${userInfo.value.permissions[0].name}`);
          }
        } else {
          await router.push({name: 'error'});
        }
      }
    });

    const APP_NAME = ref(process.env.VUE_APP_NAME);
    return {APP_NAME};
  }
});
</script>

<template>
  <metainfo>
    <template v-slot:title="{ content }">{{ content ? `${content} | ${APP_NAME}` : `${APP_NAME}` }}</template>
  </metainfo>

  <router-view/>
</template>

<style lang="scss">
nav {
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
